export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-[#E8EAED]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0A1128]">Simple. Secure. Seamless.</h2>
        </div>

        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-[#00D9FF] via-[#00D9FF] to-[#00D9FF] transform -translate-y-1/2"></div>

          <div className="grid md:grid-cols-3 gap-12 relative">
            {/* Step 1 */}
            <div className="text-center group">
              <div className="relative inline-block mb-8">
                <div className="text-[120px] font-bold text-transparent" style={{ WebkitTextStroke: '2px #00D9FF' }}>01</div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-white rounded-full shadow-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-download-cloud-line text-5xl text-[#00D9FF]"></i>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1128] mb-4">Download</h3>
              <p className="text-gray-700 leading-relaxed max-w-xs mx-auto">
                Get our app for your device in seconds. Available for all major platforms with easy installation.
              </p>
            </div>

            {/* Step 2 */}
            <div className="text-center group md:mt-8">
              <div className="relative inline-block mb-8">
                <div className="text-[120px] font-bold text-transparent" style={{ WebkitTextStroke: '2px #00D9FF' }}>02</div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-white rounded-full shadow-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-server-line text-5xl text-[#00D9FF]"></i>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1128] mb-4">Connect</h3>
              <p className="text-gray-700 leading-relaxed max-w-xs mx-auto">
                Choose a server location and connect with one click. Fast, reliable connections every time.
              </p>
            </div>

            {/* Step 3 */}
            <div className="text-center group">
              <div className="relative inline-block mb-8">
                <div className="text-[120px] font-bold text-transparent" style={{ WebkitTextStroke: '2px #00D9FF' }}>03</div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-white rounded-full shadow-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-shield-check-line text-5xl text-[#00D9FF]"></i>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1128] mb-4">Browse</h3>
              <p className="text-gray-700 leading-relaxed max-w-xs mx-auto">
                Enjoy complete privacy and freedom online. Your data is encrypted and your identity protected.
              </p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-24 relative overflow-hidden rounded-3xl">
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A1128] via-[#0A1128] to-[#00D9FF]"></div>
          <div className="relative z-10 px-8 py-16 md:py-20">
            <div className="max-w-4xl mx-auto text-center">
              <div className="mb-8">
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">Ready to protect your privacy?</h3>
                <p className="text-[#00D9FF] text-lg">Join thousands securing their digital life</p>
              </div>
              <div className="flex flex-wrap justify-center gap-4">
                <button className="bg-white text-[#0A1128] px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-fill text-xl"></i>
                  macOS
                </button>
                <button className="bg-white text-[#0A1128] px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-fill text-xl"></i>
                  iPhone
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}